export const MAX_EMAIL_LENGTH = 50;
export const MAX_FIRST_NAME_LENGTH = 100;
export const MAX_LAST_NAME_LENGTH = 100;
export const MAX_FREE_TEXT_LENGTH = 600;
export const MAX_CUSTOM_ITEM_LENGTH = 40;
export const ONE_TIME_PASSWORD_LENGTH = 6;